import { useState, useEffect } from "react";
import { Home, HomeDetail } from "./types";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setDataHome } from "./slice";
import api from "../../../api/axios";
import axios from "axios";
import { formatDateTime, formatDateTimeRange } from "../../../util/date-format";
// import { useMediaQuery } from "@mui/material";
// import { useSelector } from "react-redux";

const useSummary = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const isMobile = useMediaQuery('(max-width:600px)');
    // const { consignees } = useSelector((state: any) => state.Auth.user) || { consignees: [] };

    // Dialog states
    const [open, setOpen] = useState(false);
    const [trackingUrl, setTrackingUrl] = useState('');
    const [uploadOpen, setUploadOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerBottomOpen, setDrawerBottomOpen] = useState(false);
    const [trackingDialogOpen, setTrackingDialogOpen] = useState(false);
    const [fileDeleteConfirmOpen, setFileDeleteConfirmOpen] = useState(false);
    const [fileToDelete, setFileToDelete] = useState({ bookingNo: '', filename: '' });

    // Loading states
    const [isLoading, setIsLoading] = useState(false);
    const [locationLoading, setLocationLoading] = useState(false);
    const [consigneeLoading, setConsigneeLoading] = useState(false);
    const [homeDetailLoading, setHomeDetailLoading] = useState(false);

    // Data states
    const [dataGrid, setDataGrid] = useState<Home[]>([]);
    const [dataItem, setDataItem] = useState<Home>({
        id: 0,
        pol: '',
        pod: '',
        sn_number: '',
        milestone: '',
        etd_vessel: '',
        booking_no: '',
        reference_no: '',
        consignee_name: '',
        last_activity: '',
        eta_end_destination: '',
        last_activities_time: '',
        locations: [],
        etd_eta: ''
    });
    const [homeDetail, setHomeDetail] = useState<any>(null);
    const [homeDetailGrid, setHomeDetailGrid] = useState<HomeDetail[]>([]);
    const [milestoneCounts, setMilestoneCounts] = useState([]);

    // File states
    const [fileTypes, setFileTypes] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState<Array<{
        file: File | null;
        name: string;
        isExisting: boolean;
        format?: string;
    }>>([]);

    // Filter & Search states
    const [searchQuery, setSearchQuery] = useState('');
    const [isError, setIsError] = useState({ isError: false, message: '' });
    const [isSuccess, setIsSucces] = useState({ status: false, message: '' });
    const [pagination, setPagination] = useState({ page: 0, limit: 5, total: 0 });
    const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' } | null>({ key: 'inserted_date', direction: 'desc' });

    // Consignee states
    const [consigneeInputValue, setConsigneeInputValue] = useState('');
    const [consigneeData, setConsigneeData] = useState<{ id: number, customer_name: string }[]>([]);
    const [selectedConsignee, setSelectedConsignee] = useState<{ id: number, customer_name: string } | null>(null);

    const [isAppendData, setIsAppendData] = useState(false);
    // Location states
    const [delay, setDelay] = useState(undefined);
    const [unarrived, setUnarrived] = useState(undefined);
    const [withattachment, setWithAttachment] = useState(undefined);
    const [locationInputValue, setLocationInputValue] = useState('');
    const [locationData, setLocationData] = useState<{ loc_code: string, loc_desc: string }[]>([]);
    const [selectedLocation, setSelectedLocation] = useState<{ loc_code: string, loc_desc: string } | null>(null);

    // Milestone status states
    const [milestoneStatus, setMilestoneStatus] = useState<string | null>(null);

    // Date states
    const [dateTo, setDateTo] = useState<moment.Moment | null>(null);
    const [dateFrom, setDateFrom] = useState<moment.Moment | null>(null);

    // Global filter state
    const [filterGlobal, setFilterGlobal] = useState<{
        pol: string,
        pod: string,
        sn_number: string,
        booking_no: string,
        reference_no: string,
        last_activity: string,
        consignee_name: string,
        last_activity_time?: {
            from: string,
            to: string
        }
    } | null>(null);

    const [filterGlobalAnd, setFilterGlobalAnd] = useState<{
        pod: string,
        consignee_name: string,
    } | null>(null);

    // Fetch SCAC code for tracking
    const fetchSCAC = async (containerNumber: string) => {
        try {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/tracking-details/scac-iata/kppler`, {
                params: {
                    bookingNo: containerNumber
                }
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching container tracking:', error);
            setIsError({ isError: true, message: 'Error fetching container tracking: ' + error.message });
            return null;
        }
    };

    const fetchTrackingRequest = async (shipmentID: string) => {
        try {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/marine-traffic/tracking-request/${shipmentID}`);

            return response.data;
        } catch (error) {
            console.error('Error fetching container tracking:', error);
            setIsError({ isError: true, message: 'Error fetching container tracking: ' + error.message });
            return null;
        }
    };

    // Fetch Kpler tracking data
    const fetchKplerTracking = async (data: any[]) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/marine-traffic/bulk-track-container`, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching container tracking:', error);
            setIsError({ isError: true, message: 'Error fetching container tracking: ' + error.message });
            return null;
        }
    };

    const fetchConsigneeData = async (searchTerm = '') => {
        try {
            setConsigneeLoading(true);
            const filter = {
                customer_name: searchTerm,
            }
            const response = await api.get(`/consignee`, {
                params: {
                    filter: JSON.stringify(filter),
                    limit: 1000
                }
            });
            setConsigneeData(response.data.items.map(item => ({
                ...item,
                id: item.customer_id,
                label: `${item.customer_name} - ${item.customer_id}`
            })) || []);
            setConsigneeLoading(false);
        } catch (error) {
            console.error("Error fetching consignee data:", error);
            setConsigneeLoading(false);
            setConsigneeData([]);
        }
    };

    const fetchLocationData = async () => {
        try {
            setLocationLoading(true);
            const filterLocal = {
                ...filterGlobal,
                card: undefined,
                "and_filter": filterGlobalAnd
            }
            // Use the new API endpoint to fetch distinct ship-to points
            const response = await api.get('/home/distinct-ship-to-points', {
                params: {
                    filter: JSON.stringify(filterLocal),
                }
            });

            // Transform the response data to the expected format
            const formattedData = response.data.items.map(item => ({
                ...item,
                loc_code: item.ship_to_point_id,
                loc_desc: item.ship_point_desc,
                label: `${item.ship_point_desc} (${item.ship_to_point_id})`
            }));

            setLocationData(formattedData || []);
            setLocationLoading(false);
        } catch (error) {
            console.error("Error fetching location data:", error);
            setLocationLoading(false);
            setLocationData([]);
        }
    };

    const fetchHomeData = async () => {
        try {
            setIsLoading(true);
            const sort = {
                [sortConfig?.key]: sortConfig?.direction,
            }
            const filterLocal = {
                ...filterGlobal,
                "and_filter": filterGlobalAnd
            }

            const response = await api.get('/home', {
                params: {
                    page: pagination.page + 1,
                    size: pagination.limit,
                    filter: JSON.stringify(filterLocal),
                    sort: sort ? JSON.stringify(sort) : null
                }
            });
            const result = response.data;
            setPagination(prev => ({ ...prev, total: result.totalItems }));

            const formattedItems = result.items.map((item: any, index: number) => ({
                ...item,
                id: isAppendData ? dataGrid.length + index + 1 : index + 1,
                etd_vessel: formatDateTime(item.etd_vessel),
                eta_end_destination: formatDateTime(item.eta_end_destination),
                etd_eta: formatDateTimeRange(item.etd_vessel, item.eta_end_destination),
                consignee_name_code: `${item.consignee_name} ${item.customer_id ? `(${item.customer_id})` : ''}`,
                inserted_date: formatDateTime(item.inserted_date),
                last_activity_time: formatDateTime(item.last_activity_time),
                shipment_created_date: formatDateTime(item.shipment_created_date),
            }));

            if (isAppendData) {
                setDataGrid(prevData => [...prevData, ...formattedItems]);
            } else {
                setDataGrid(formattedItems);
            }

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            const errorMessage = error.response ? error.response.data.error : 'Unknown error';
            setIsError({ isError: true, message: 'Error fetching data: ' + errorMessage });
            console.error("Error fetching data:", error);
        }
    };

    const fetchMilestoneCounts = async () => {
        try {
            const filterLocal = {
                ...filterGlobal,
                "and_filter": filterGlobalAnd ? filterGlobalAnd : undefined
            }
            const response = await api.get(`/home/milestone-counts`, {
                params: {
                    filter: JSON.stringify(filterLocal),
                }
            });
            setMilestoneCounts(response.data);
        } catch (error) {
            console.error("Error fetching milestone counts:", error);
        }
    };

    const fetchHomeDetail = async (bookingNo: string) => {
        try {
            setHomeDetailLoading(true);
            const response = await api.get(`/home-details`, {
                params: {
                    filter: JSON.stringify({ booking_no: bookingNo }),
                    size: 1000,
                    page: 1,
                }
            });
            const responseDetail = await api.get(`/tracking-details`, {
                params: {
                    filter: JSON.stringify({ booking_no: bookingNo }),
                    size: 1000,
                    page: 1,
                },
            });

            const dataHome = dataGrid.find(i => i.booking_no == bookingNo)
            // Sort response data items by trip plan ID (extract numeric part and find the biggest)
            const sortedItems = [...response.data.items].sort((a, b) => {
                // Extract numeric part from trip_plan_id (e.g., TP25-082395 -> 25082395)
                const getNumericPart = (tripPlanId) => {
                    if (!tripPlanId) return 0;
                    const matches = tripPlanId.match(/TP(\d+)-(\d+)/);
                    if (matches && matches.length >= 3) {
                        return parseInt(matches[1] + matches[2]);
                    }
                    return 0;
                };

                const numA = getNumericPart(a.trip_plan_id);
                const numB = getNumericPart(b.trip_plan_id);
                return numB - numA; // Descending order (biggest first)
            });

            // Get the item with the biggest trip plan ID (first item after sorting)
            const dataHomeDetail = sortedItems.length > 0 ? sortedItems[0] : response.data.items.find(i => i.booking_no == bookingNo);
            setHomeDetail({
                ...response.data.items[0],
                ...dataHome,
                quantity: dataHomeDetail?.quantity ? parseFloat(parseFloat(dataHomeDetail.quantity).toFixed(2)) : null,
                bl_number: dataHomeDetail?.bl_number,
            });


            setHomeDetailGrid(responseDetail.data.items.map((item: any) => ({
                ...item,
                commodity: dataHomeDetail?.commodity,
                quantity: dataHomeDetail?.quantity ? parseFloat(parseFloat(dataHomeDetail.quantity).toFixed(2)) : null,
                weight: dataHomeDetail?.weight ? parseFloat(parseFloat(dataHomeDetail.weight).toFixed(2)) : null,
                volume: dataHomeDetail?.volume ? parseFloat(parseFloat(dataHomeDetail.volume).toFixed(2)) : null,
                dangerous_goods: dataHomeDetail?.dangerous_goods,
                receiver_name: dataHomeDetail?.receiver_Name,
                remarks: dataHomeDetail?.remarks,
            })));
            setHomeDetailLoading(false);
            return response.data;
        } catch (error) {
            console.error("Error fetching home detail:", error);
            setHomeDetailLoading(false);
            setHomeDetail(null);
            return null;
        }
    };

    let timeout: NodeJS.Timeout;
    const handleSearchChange = (value: string) => {
        clearTimeout(timeout);
        // Use a shorter timeout for better mobile performance
        const timeoutDuration = 300; // Reduced from searchTypingTimeout (500ms)

        timeout = setTimeout(() => {
            setSearchQuery(value);
            setPagination(prev => ({ ...prev, page: 0 }));
        }, timeoutDuration);
    };

    const handleUploadOpen = (id, item) => {
        setDataItem(item);

        // Initialize empty files array
        const files = [];

        // Check if item has attachments and load them
        if (item.attachments && item.attachments.length > 0) {
            // Map existing attachments to our file format
            const existingFiles = item.attachments.map(attachment => ({
                file: null, // We don't have the actual File object for existing attachments
                name: attachment.filename || attachment.file_name || 'Unknown file',
                isExisting: true,
                format: attachment.file_format || ''
            }));

            files.push(...existingFiles);

            // Initialize fileTypes for existing files
            const initialFileTypes = {};
            existingFiles.forEach((file, index) => {
                if (file.format) {
                    initialFileTypes[index] = file.format;
                }
            });
            setFileTypes(initialFileTypes);
        }

        // Set the uploadedFiles state with existing files
        setUploadedFiles(files);
        setUploadOpen(true);
    };

    const handleUploadClose = () => {
        setUploadOpen(false);
        // Reset files and types when closing
        setUploadedFiles([]);
        setFileTypes({});
    };

    const handleFileChange = (event) => {
        const newFiles = Array.from(event.target.files as FileList);
        // Add new files with isExisting set to false
        const formattedNewFiles = newFiles.map(file => ({
            file: file as File,
            name: file.name,
            isExisting: false
        }));

        // Append to existing files
        setUploadedFiles(prevFiles => [...prevFiles, ...formattedNewFiles]);
    };

    const handleRemoveFile = (index) => {
        // Only allow removing non-existing files
        setUploadedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));

        // Also remove any file type associated with this file
        const updatedFileTypes = { ...fileTypes };
        delete updatedFileTypes[index];

        // Remap indexes for files after the deleted one
        const newFileTypes = {};
        Object.keys(updatedFileTypes).forEach(key => {
            const keyNum = parseInt(key);
            if (keyNum > index) {
                newFileTypes[keyNum - 1] = updatedFileTypes[key];
            } else {
                newFileTypes[keyNum] = updatedFileTypes[key];
            }
        });

        setFileTypes(newFileTypes);
    };

    const handleViewDetail = (id, item) => {
        dispatch(setDataHome(item));
        navigate(`/dashboards/summary/detail/${encodeURIComponent(id)}`);
    };

    const linkwebview = 'https://www.marinetraffic.com/track-shipment?id=';

    const handleTrackingKppler = async (item: any) => {
        if (item.transport_mode !== 'Ocean') return;
    
        try {
            const scac = await fetchSCAC(item.booking_no);
            if (!scac || scac.length === 0) {
                throw new Error('Failed to fetch SCAC code');
            }
    
            const kplerData = await fetchKplerTracking(scac);
            if (!kplerData) {
                throw new Error('Failed to fetch Kpler tracking data');
            }
    
            const urlsToOpen = new Set<string>();
    
            // Handle errors
            if (kplerData.apiResponse.errors?.length > 0) {
                for (const err of kplerData.apiResponse.errors) {
                    if (err.code === 'NOT_FOUND') {
                        throw new Error('No tracking data found');
                    }
    
                    if (err.code === 'resource_already_exists') {
                        const link = err.links.about;
                        const trackingID = link.substring(link.lastIndexOf('/') + 1);
    
                        const trackingRequest = await fetchTrackingRequest(trackingID);
                        const shipmentId =
                            trackingRequest?.data?.relationships?.shipment?.data?.shipmentId;
    
                        if (shipmentId) {
                            urlsToOpen.add(linkwebview + shipmentId);
                        }
                    }
                }
            } else {
                for (const dataItem of kplerData.apiResponse.data) {
                    if (dataItem.scac === scac[0].scac) {
                        const shipmentID =
                            dataItem.link.substring(dataItem.link.lastIndexOf('/') + 1);
    
                        urlsToOpen.add(linkwebview + shipmentID);
                    }
                }
            }
    
            // ✅ Open unique URLs only (reuse tab if same URL)
            urlsToOpen.forEach((url) => {
                const windowName = `marine_${btoa(url)}`;
                setTrackingUrl(url);
                window.open(url, windowName);
            });
    
        } catch (error) {
            console.error('Error tracking container:', error);
            setIsError({
                isError: true,
                message:
                    error instanceof Error
                        ? error.message
                        : 'Error tracking container'
            });
        }
    };

    const handleClickFilter = () => {
        setDrawerBottomOpen(true);
    };

    const toggleDrawer = (open) => (event) => {
        // Don't close drawer when typing in input fields
        if (
            event &&
            event.type === 'keydown' &&
            (
                event.key === 'Tab' ||
                event.key === 'Shift' ||
                // Prevent closing when target is an input element or any of its children
                (event.target && (
                    event.target.tagName === 'INPUT' ||
                    event.target.tagName === 'TEXTAREA' ||
                    event.target.isContentEditable ||
                    event.target.closest('input') ||
                    event.target.closest('textarea') ||
                    event.target.closest('[role="combobox"]') ||
                    event.target.closest('[role="listbox"]') ||
                    event.target.closest('[role="textbox"]') ||
                    event.target.closest('.MuiAutocomplete-root')
                ))
            )
        ) {
            return;
        }

        // Also don't process events from autocomplete dropdown options
        if (event && event.target && event.target.closest('.MuiAutocomplete-popper')) {
            return;
        }

        setDrawerOpen(open);
    };

    const toggleDrawerBottom = (open) => (event) => {
        // Don't close drawer when typing in input fields
        if (
            event &&
            event.type === 'keydown' &&
            (
                event.key === 'Tab' ||
                event.key === 'Shift' ||
                // Prevent closing when target is an input element or any of its children
                (event.target && (
                    event.target.tagName === 'INPUT' ||
                    event.target.tagName === 'TEXTAREA' ||
                    event.target.isContentEditable ||
                    event.target.closest('input') ||
                    event.target.closest('textarea') ||
                    event.target.closest('[role="combobox"]') ||
                    event.target.closest('[role="listbox"]') ||
                    event.target.closest('[role="textbox"]') ||
                    event.target.closest('.MuiAutocomplete-root')
                ))
            )
        ) {
            return;
        }

        // Also don't process events from autocomplete dropdown options
        if (event && event.target && event.target.closest('.MuiAutocomplete-popper')) {
            return;
        }

        setDrawerBottomOpen(open);
    };

    const handleFileTypeChange = (index, event) => {
        setFileTypes(prevTypes => ({
            ...prevTypes,
            [index]: event.target.value
        }));
    };

    const submitDocuments = async () => {
        try {
            // Filter only new files that need to be uploaded
            const newFiles = uploadedFiles.filter(file => !file.isExisting);

            // Check if there are new files to upload
            if (newFiles.length === 0) {
                setIsError({ isError: true, message: 'No new files to upload' });
                return false;
            }

            // Check if all new files have a document type selected
            const newFileIndexes = uploadedFiles
                .map((file, index) => ({ file, index }))
                .filter(item => !item.file.isExisting)
                .map(item => item.index);

            const hasAllFileTypes = newFileIndexes.every(index => fileTypes[index]);
            if (!hasAllFileTypes) {
                setIsError({ isError: true, message: 'Please select document type for all new files' });
                return false;
            }

            // Create FormData object
            const formData = new FormData();

            // Add booking_no to FormData
            formData.append('booking_no', dataItem.booking_no);

            // Add only new files and their types to FormData
            newFileIndexes.forEach(index => {
                formData.append('files', uploadedFiles[index].file);
                formData.append('file_format', fileTypes[index]);
            });

            // Set content type to multipart/form-data
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            };

            // Send request to upload API on port 3004
            await axios.post(process.env.REACT_APP_BUCKET_API_URL + '/attachments/upload', formData, config);

            // Clear uploaded files and file types after successful upload
            setUploadedFiles([]);
            setFileTypes({});
            setUploadOpen(false);

            // Show success message
            setIsSucces({ status: true, message: 'Documents uploaded successfully!' });
            fetchHomeData()
            return true;
        } catch (error) {
            console.error("Error uploading documents:", error);
            const errorMessage = error.response ? error.response.data.error : 'Failed to upload documents';
            setIsError({ isError: true, message: errorMessage });
            return false;
        }
    };

    const handleFileDeleteConfirm = (bookingNo, filename) => {
        setFileToDelete({ bookingNo, filename });
        setFileDeleteConfirmOpen(true);
    };

    const deleteFile = async () => {
        try {
            // Send request to delete file API
            await axios.delete(process.env.REACT_APP_BUCKET_API_URL + `/attachments/${encodeURIComponent(fileToDelete.bookingNo)}/${encodeURIComponent(fileToDelete.filename)}`);

            // Remove the deleted file from the uploadedFiles list if it exists there
            setUploadedFiles(prevFiles =>
                prevFiles.filter(file => !(file.isExisting && file.name === fileToDelete.filename))
            );

            // Show success message
            setIsSucces({ status: true, message: 'File deleted successfully!' });

            // Close the confirmation dialog
            setFileDeleteConfirmOpen(false);

            // Refresh data to reflect the changes
            fetchHomeData();

            return true;
        } catch (error) {
            console.error("Error deleting file:", error);
            const errorMessage = error.response ? error.response.data.error : 'Failed to delete file';
            setIsError({ isError: true, message: errorMessage });
            setFileDeleteConfirmOpen(false);
            return false;
        }
    };

    const loadMoreData = () => {
        // Only load more if we haven't reached the total items
        if (dataGrid.length < pagination.total && !isLoading) {
            setIsAppendData(true)
            setPagination(prev => ({ ...prev, page: prev.page + 1 }));
        }
    };

    useEffect(() => {
        if (filterGlobal) {
            fetchHomeData();
        }
    }, [pagination.page, pagination.limit, filterGlobal, sortConfig]);

    useEffect(() => {
        if (filterGlobal) {
            fetchMilestoneCounts();
            fetchLocationData()
        }
    }, [sortConfig, filterGlobal]);

    useEffect(() => {
        let filter: any = {
            pol: searchQuery !== '' ? searchQuery : undefined,
            sn_number: searchQuery !== '' ? searchQuery : undefined,
            booking_no: searchQuery !== '' ? searchQuery : undefined,
            reference_no: searchQuery !== '' ? searchQuery : undefined,
            last_activity: searchQuery !== '' ? searchQuery : undefined,
            transport_mode: searchQuery !== '' ? searchQuery : undefined,

            card: milestoneStatus ? milestoneStatus : undefined,
            withAttachment: withattachment ? withattachment : undefined,
            Delay: delay ? delay : undefined,
            unarrived: unarrived ? unarrived : undefined,
        };

        let filterAnd: any = {
            ship_to_point_id: selectedLocation ? selectedLocation.loc_code : undefined,
            customer_id: selectedConsignee ? selectedConsignee.id : undefined,
        };

        // Add date range filter if both dates are set
        if (dateFrom && dateTo) {
            filter.shipment_created_date = {
                from: dateFrom.format('YYYY-MM-DD'),
                to: dateTo.format('YYYY-MM-DD')
            };
        }
        setFilterGlobal(filter);
        setFilterGlobalAnd(filterAnd);
        setPagination({ page: 0, limit: pagination.limit, total: 0 });

    }, [searchQuery, selectedConsignee, selectedLocation, dateFrom, dateTo, milestoneStatus, unarrived, delay, withattachment]);


    return {
        data: {
            open,
            dateTo,
            isError,
            dataGrid,
            dataItem,
            dateFrom,
            isSuccess,
            isLoading,
            fileTypes,
            pagination,
            deleteOpen,
            uploadOpen,
            drawerOpen,
            sortConfig,
            searchQuery,
            homeDetail,
            trackingUrl,
            locationData,
            uploadedFiles,
            fileToDelete,
            consigneeData,
            homeDetailGrid,
            milestoneCounts,
            locationLoading,
            milestoneStatus,
            drawerBottomOpen,
            selectedLocation,
            consigneeLoading,
            homeDetailLoading,
            selectedConsignee,
            locationInputValue,
            trackingDialogOpen,
            consigneeInputValue,
            fileDeleteConfirmOpen,
        },
        method:
        {
            setOpen,
            setDelay,
            setDateTo,
            setIsError,
            deleteFile,
            setDataItem,
            setDataGrid,
            setIsSucces,
            setDateFrom,
            setIsLoading,
            toggleDrawer,
            loadMoreData,
            setUnarrived,
            setPagination,
            setDeleteOpen,
            setSortConfig,
            setUploadOpen,
            fetchHomeDetail,
            submitDocuments,
            setIsAppendData,
            handleFileChange,
            handleUploadOpen,
            handleRemoveFile,
            handleViewDetail,
            fetchLocationData,
            handleUploadClose,
            setWithAttachment,
            handleClickFilter,
            setMilestoneStatus,
            toggleDrawerBottom,
            handleSearchChange,
            fetchConsigneeData,
            setSelectedLocation,
            handleTrackingKppler,
            handleFileTypeChange,
            fetchMilestoneCounts,
            setSelectedConsignee,
            setTrackingDialogOpen,
            setLocationInputValue,
            setConsigneeInputValue,
            handleFileDeleteConfirm,
            setFileDeleteConfirmOpen,
        }
    };
}

export { useSummary };
